<template>
  <div>
    <dialog-user
      @close="closeDialogHandleUser"
      @update="update"
      :id="id"
      :isVisible="dialogVisible.editUser"
    />

    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>
            Usuarios registrados
          </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <!-- Table Logs -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">
          <div slot="header" style="text-align: right;">
            <el-button type="primary" icon="el-icon-plus" @click="addUser"
              >Agregar Usuario</el-button
            >
          </div>

          <el-table
            :data="users"
            style="width: 100%"
            :default-sort="{ prop: 'name', order: 'descending' }"
            stripe
          >
            <el-table-column
              label="Nombre"
              prop="carrier"
              align="center"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-user"></i>
                  {{ props.row.name }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column label="Email" align="center" width="300">
              <template slot-scope="props">
                <h4>
                  <i class="el-icon-email"></i>
                  {{ props.row.email }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Fecha de Creacion"
              align="center"
              prop="created_at"
              sortable
            >
              <template slot-scope="props">
                <i class="el-icon-time"></i>
                {{ props.row.createdAt | formatDate }}
              </template>
            </el-table-column>

            <el-table-column
              label="Ultima Modificacion"
              align="center"
              prop="updated_at"
              sortable
            >
              <template slot-scope="props">
                <i class="el-icon-time"></i>
                {{ props.row.updatedAt | formatDate }}
              </template>
            </el-table-column>

            <el-table-column
              label="Ultimo Acceso"
              align="center"
              prop="last_login"
              sortable
            >
              <template slot-scope="props">
                {{ props.row.lastLogin | timeAgo }}
              </template>
            </el-table-column>

            <el-table-column label="Nivel" align="center" width="110">
              <template slot-scope="props">
                <el-tag effect="plain">
                  {{ props.row.role.toUpperCase() }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="Operaciones">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  round
                  @click="handleEditUser(scope.$index, scope.row)"
                  >Editar
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <!-- END Table Logs -->
    <br />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DialogUser from "@/components/DialogUser";
import { CSApi } from "@/libraries/api";

export default {
  name: "Users",
  components: {
    DialogUser,
  },
  data() {
    return {
      users: {},
      id: null,
      dialogVisible: {
        editUser: false,
      },
    };
  },
  methods: {
    async addUser() {
      this.id = null;
      this.dialogVisible.editUser = true;
    },

    async editUser(id) {
      this.id = id;
      this.dialogVisible.editUser = true;
    },

    closeDialogHandleUser() {
      this.dialogVisible.editUser = false;
    },

    async update() {
      try {
        const response = await CSApi().get(
          "/coverage/user?page=1&pageSize=500"
        );
        const { data } = response.data;
        this.users = data;
      } catch (error) {
        console.log(error.response);
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
    handleEditUser(_, data) {
      this.editUser(data.id);
    },
  },
  async mounted() {
    await this.update();
  },
};
</script>

<style scoped>
.el-timeline {
  overflow-y: auto;
  height: 100vh;
  padding-top: 20px;
}

pre {
  margin: 0px 30px;
}
</style>
